/**
 * Logo Animation with GSAP
 *
 * This script provides various logo animation options using the free GSAP core library.
 *
 * Usage:
 * 1. Replace your logo image with an inline SVG
 * 2. Add appropriate IDs/classes to your SVG elements
 * 3. Call the desired animation function
 */

class LogoAnimation {
  constructor() {
    this.logo = document.querySelector(".header-logo");
    // Only target the original logo container, not the inverse one
    this.originalLogoContainer = this.logo?.querySelector(
      ".header-logo__image-container--original"
    );
    this.svg = this.originalLogoContainer?.querySelector("svg");
    this.drawPaths = this.svg?.querySelectorAll("path.draw-me");

    if (!this.svg) {
      console.warn("Logo Animation: No SVG found in original header logo");
      return;
    }

    this.init();
  }

  init() {
    // Wait for GSAP and DrawSVG to be available
    if (typeof gsap === "undefined") {
      console.warn("Logo Animation: GSAP not loaded");
      return;
    }

    if (typeof DrawSVGPlugin === "undefined") {
      console.warn("Logo Animation: DrawSVG plugin not loaded");
      return;
    }

    // Register the DrawSVG plugin
    gsap.registerPlugin(DrawSVGPlugin);
  }

  // Animation: Draw SVG paths using DrawSVG plugin
  animateDrawSVG() {
    const paths = this.drawPaths;
    if (paths.length === 0) {
      console.warn("Logo Animation: No stroke paths found for draw animation");
      return;
    }

    // Use DrawSVG plugin to animate paths
    gsap.from(paths, {
      drawSVG: 0,
      duration: 3,
      ease: "power2.out",
      opacity: 0,
    });

    // gsap.fromTo(
    //   this.svg,
    //   {
    //     backgroundColor: "transparent",
    //     /* in order: x offset, y offset, blur size, spread size, color */
    //     boxShadow: "0px 0px 0px 0px transparent",
    //     borderRadius: "100px",
    //   },
    //   {
    //     backgroundColor: "#cccccc",
    //     borderRadius: "100px",
    //     boxShadow: "0px 0px 60px 60px #cccccc",
    //     duration: 1,
    //     onComplete: () => {
    //       gsap.to(this.svg, {
    //         backgroundColor: "transparent",
    //         borderRadius: "100px",
    //         boxShadow: "0px 0px 50px 50px transparent",
    //         duration: 1,
    //       });
    //     },
    //   }
    // );
  }
}
// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Wait a bit for GSAP to load
  setTimeout(() => {
    const logoAnim = new LogoAnimation();
    logoAnim.animateDrawSVG(); // For SVG with stroke paths
  }, 100);
});

// Export for manual use
window.LogoAnimation = LogoAnimation;
